var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 32,
    viewBox: "0 0 165 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 15,
    width: 164.5,
    height: 2,
    fill: "#4b5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressLine);
export default __webpack_public_path__ + "static/media/progressLine.5696d1e8162655daa9228d49dd342614.svg";
export { ForwardRef as ReactComponent };